import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-disc-grp-prods',
  templateUrl: './disc-grp-prods.component.html',
  styleUrls: ['./disc-grp-prods.component.css']
})
export class DiscGrpProdsComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private createGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_discgrpprods_grid')
                .setLoadDataFunction({ method: 3112, parameters: {} })
                .setKendoConfig({ height: '100%' })
                .setCustomToolbarButtons([{
                    name: 'discgrpprods_new',
                    text: 'discgrpprods_new',
                    func: () => this.stateService?.go('discgrpprod', { discgrpprod_keyno: '0' }),
                    icon: 'fas fa-plus', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        }
    }

    private async init() {
        this.createGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpProds', {
//        templateUrl: 'views/components/views/discGrpProds/discGrpProds.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_discgrpprods_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setLoadDataFunction({
//                method: 3112,
//                parameters: {}
//            }).setCustomToolbarButtons([{
//                name: 'discgrpprods_new',
//                text: 'discgrpprods_new',
//                func: () => stateService.go('discgrpprod', { discgrpprod_keyno: '0' }),
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
